import ParameterValidator from '@mvps-genesis/parameter-validator';
import {tabbable} from 'tabbable';

export default class SkipToSection {

	// We reverse the array so they are inserted in the proper order
	static createFromArray (sections) {
		return Array.from(sections)
			.reverse()
			.map(section => new this(section))
			.reverse();
	}

	_rulesets = {
		options: {
			label: 'String',
			targetElement: 'Element'
		}
	};

	constructor (options) {
		// Create validator
		this._validator = new ParameterValidator(this);

		// Validate and silently fail
		try {
			this._options = options;
			this.options = this._validator.validate('options', options, this._rulesets.options);
		}
		catch (e) {
			// eslint-disable-next-line no-console
			console.warn(e);
			return false;
		}

		this.init();
	}

	init () {
		this.createNav();
		this.element = this.createElement();
		this.bindEvents();
		this.insertElement();
	}

	createNav () {

		const navId = 'skip-to-section-nav';
		let nav = document.getElementById(navId);

		if (nav) {
			this.nav = nav;
		} else {
			nav = document.createElement('nav');
			nav.id = navId;
			nav.setAttribute('aria-label', 'Genesis, skip-to-section-nav');
			document.body.insertBefore(nav, document.body.firstChild);
			this.nav = nav;
		}
	}

	createElement () {
		const element = document.createElement('button');

		const label = `Skip to "${this.options.label}"? Press ENTER.`;
		element.innerText = label;
		element.setAttribute('aria-label', label);
		element.type = 'button';
		element.tabIndex = 0;
		element.style.position = 'absolute';
		element.style.top = '-100%';
		element.className = 'g-skip-to__button';

		return element;
	}

	bindEvents () {
		this.element.addEventListener('click', this.onClick);
		this.element.addEventListener('keydown', this.onKeyDown);
	}

	destroyEvents () {
		this.element.removeEventListener('click', this.onClick);
		this.element.removeEventListener('keydown', this.onKeyDown);
	}

	insertElement () {
		this.nav.appendChild(this.element);
	}

	/* eslint-disable no-invalid-this */
	onClick = (e) => {
		e.preventDefault();

		this.scrollToTargetElement(e);
	};

	onKeyDown = (e) => {
		switch (e.key) {

			case 'Enter':
				e.preventDefault();
				this.scrollToTargetElement(e);
				return true;

			default:
				return false;

		}
	};
	/* eslint-enable no-invalid-this */

	scrollToTargetElement () {
		const tabbableElements = tabbable(this.options.targetElement, {includeContainer: true});

		if (tabbableElements && tabbableElements.length) {
			tabbableElements[0].scrollIntoView({behavior: 'smooth'});
			tabbableElements[0].focus();
		}
		else {
			// eslint-disable-next-line no-console
			console.warn(`${this.constructor.name} :: Unable to find tabbable element within section target element`);

		}
	}

};
